import { cn } from '../lib/utils';
import { clientStockStyle, clientMonogram } from '../lib/cardStock';

/**
 * A client's monogram on their card stock, the same colour as every one of
 * their job cards. Decorative: the client's name is always written beside it.
 */
export function ClientMark({ name, className }) {
  return (
    <span
      aria-hidden="true"
      className={cn('on-stock inline-grid place-content-center shrink-0 w-8 h-8 rounded-full text-[11px] font-bold tracking-[0.02em]', className)}
      style={clientStockStyle(name)}
    >
      {clientMonogram(name)}
    </span>
  );
}
